export function getParam<T = string>(key: string): T | undefined | null {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(key) as T
}
